export default __webpack_public_path__ + "static/media/feature-right-mobile-NZ.443b123b.png";